import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CocaColaValuesGameHccbComponent } from './coca-cola-values-game-hccb.component';

const routes: Routes = [
  {
    path: '',
    component: CocaColaValuesGameHccbComponent,
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CocaColaValuesGameHccbRoutingModule {}
